import { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface QuotePricingFinancialSummaryProps {
  totalHours: number
  baseCostCents: number
  baseAmountCents: number
  totalAmountCents: bigint
  taxesTotalAmountCents: number
  currency: string
  locale: string
  isProductQuote: boolean
}
const QuotePricingFinancialSummary = ({
  totalHours,
  baseCostCents,
  baseAmountCents,
  taxesTotalAmountCents,
  totalAmountCents,
  currency,
  locale,
  isProductQuote,
}: QuotePricingFinancialSummaryProps) => {
  const buildDetailItemMoneyContent = (
    amountCents: number
  ): ComponentProps<typeof DetailsItemsList>['details'][number]['content'] => {
    return {
      type: 'item',
      text: MoneyWithCurrency({
        optionalDecimals: true,
        amount: amountCents,
        currency: currency,
        locale,
      }).toString(),
    }
  }
  const hoursAndCostsDetails: ComponentProps<typeof DetailsItemsList>['details'] = [
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.total_hours'),
      content: {
        type: 'item',
        text: totalHours + 'h',
      },
    },
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.estimated_costs'),
      content: buildDetailItemMoneyContent(baseCostCents),
    },
  ]

  const totalDetails: ComponentProps<typeof DetailsItemsList>['details'] = [
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.subtotal'),
      content: buildDetailItemMoneyContent(baseAmountCents),
    },
    ...(isProductQuote
      ? [
          {
            title: i18n.t('finance.quotes.quote_phases_table.sumary.taxes'),
            content: buildDetailItemMoneyContent(taxesTotalAmountCents),
          },
        ]
      : []),
    {
      title: i18n.t('finance.quotes.quote_phases_table.sumary.total'),
      content: buildDetailItemMoneyContent(Number(totalAmountCents)),
    },
  ]

  const summaryTitle = i18n.t('finance.quotes.quote_phases_table.sumary.title')

  return (
    <Box flexDirection="column" gap="s16">
      {!isProductQuote && (
        <DetailsItemsList details={hoursAndCostsDetails} tableView title={summaryTitle} />
      )}
      <DetailsItemsList
        details={totalDetails}
        tableView
        title={isProductQuote ? summaryTitle : undefined}
      />
    </Box>
  )
}

export default QuotePricingFinancialSummary
